function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useEffect, useState } from 'react';
import { REDUCER_CART_NOTIFIER_NAME } from 'moduleCartNotifier/constants';
import { reducerCartNotifier } from 'moduleCartNotifier/reducers';
import { bindActionCreators } from 'redux';
import { cartNotifierLoad } from 'moduleCartNotifier/actions/load';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { CreateProjectModal } from 'moduleCartNotifier/components/CreateProjectModal';
import { CartNotifierLink } from 'moduleCartNotifier/components/CartNotifierLink';

var CartNotifier = function CartNotifier(_ref) {
  var count = _ref.count,
      load = _ref.load;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisibleCreateProjectModal = _useState2[0],
      setIsVisibleCreateProjectModal = _useState2[1];

  useEffect(function () {
    load();
  }, []);

  var createProjectModalShow = function createProjectModalShow() {
    setIsVisibleCreateProjectModal(true);
  };

  var createProjectModalHide = function createProjectModalHide() {
    setIsVisibleCreateProjectModal(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CartNotifierLink, {
    count: count,
    createProjectModalShow: createProjectModalShow
  }), /*#__PURE__*/React.createElement(CreateProjectModal, {
    isVisibleCreateProjectModal: isVisibleCreateProjectModal,
    createProjectModalHide: createProjectModalHide
  }));
};

export default connect(CartNotifier, {
  reducers: {
    name: REDUCER_CART_NOTIFIER_NAME,
    reducer: reducerCartNotifier,
    isNeedUnregister: false
  },
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_CART_NOTIFIER_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      load: cartNotifierLoad
    }, dispatch);
  }
});